// Styles
import './_main-blog.scss';